import { render, staticRenderFns } from "./SingleClientKogi.vue?vue&type=template&id=55b53d1a&scoped=true&"
import script from "./SingleClientKogi.vue?vue&type=script&lang=js&"
export * from "./SingleClientKogi.vue?vue&type=script&lang=js&"
import style0 from "./SingleClientKogi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SingleClientKogi.vue?vue&type=style&index=1&id=55b53d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b53d1a",
  null
  
)

export default component.exports